import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./StoreOrders'),
  (m) => m.StoreOrders
);
